module.exports = __webpack_public_path__ + "img/lateral-p-500.f8e0d978.jpeg";